/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import { getStaff } from '@/app/services/staff/staff';
import * as Actions from '@/app/store/actions';
import { Avatar, CircularProgress, IconButton, InputAdornment, TextField } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch } from 'react-redux';
import DisableConfirmDialog from './DisableConfirmDialog';
import './staff.css';
import CustomSwitch from '@shared/components/CustomSwitch';
import { useNavigate } from 'react-router-dom';

const StaffListing = () => {
	const dispatch = useDispatch();
	const [searchQuery, setSearchQuery] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [rows, setRows] = useState([]);
	const [firstLoad, setFirstLoad] = useState(true);
	const [fetchingMore, setFetchingMore] = useState(false);
	const [hasMore, setHasMore] = useState(false);
	const [page, setPage] = useState(1);
	const [refresh, setRefresh] = useState(false);
	const navigate = useNavigate();

	const handleSearch = (e) => {
		setSearchQuery(e.target.value);
	};
	const gotostaffinformation = (row) => {
		navigate(`/staff-info/${row.id}`, { state: { row } });
	};
	const goToEditStaff = (row) => {
		navigate(`/staff-editstaff/${row.id}`, { state: { row } });
	};

	const goToAddStaff = () => {
		navigate(`/staff-addstaff`);
	};

	const handleStatusChange = (e, row) => {
		e.preventDefault();
		dispatch(
			Actions.openDialog({
				children: <DisableConfirmDialog refresh={refresh} row={row} setRefresh={setRefresh} />,
			})
		);
	};

	const handleLoadMore = () => {
		setFetchingMore(true);
		getStaff(searchQuery, page)
			.then((res) => {
				if (res.data.last_page > res.data.current_page) {
					setHasMore(true);
				} else {
					setHasMore(false);
				}
				setPage(res.data.current_page + 1);
				setRows(rows.concat(res.data.data));
				setFetchingMore(false);
			})
			.catch(() => {
				setFetchingMore(false);
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					})
				);
			});
	};

	useEffect(() => {
		let isMounted = true;
		const id = setTimeout(
			() => {
				if (!isMounted) return;
				setIsLoading(true);
				setFirstLoad(false);
				getStaff(searchQuery)
					.then((res) => {
						if (!isMounted) return;
						if (res.data.last_page > res.data.current_page) {
							setHasMore(true);
						} else {
							setHasMore(false);
						}
						setPage(res.data.current_page + 1);
						setRows(res.data.data);
					})
					.catch(() => {
						if (!isMounted) return;
						dispatch(
							Actions.showMessage({
								message: 'Failed to fetch data, please refresh',
								variant: 'error',
							})
						);
					})
					.finally(() => {
						if (!isMounted) return;
						setIsLoading(false);
					});
			},
			firstLoad ? 0 : 1000
		);
		return () => {
			isMounted = false;
			clearTimeout(id);
		};
	}, [dispatch, searchQuery, refresh]);

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className="staff-cont mx-auto w-[95%]">
				<div className="flex justify-between items-end">
					<span className="text-pd-xl self-end font-bold mr-28">Staff List</span>
					<div className="flex justify-between">
						<TextField
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											onClick={() => {
												document.getElementById('search').focus();
											}}
										>
											<img alt="search-icon" height="80%" src="assets/images/search-icon.svg" width="80%" />
										</IconButton>
									</InputAdornment>
								),
								autoComplete: 'none',
							}}
							autoComplete="none"
							id="search"
							label="Search By Name"
							onChange={handleSearch}
							style={{
								alignSelf: 'center',
								paddingRight: 30,
							}}
							value={searchQuery}
						/>
						<div
							style={{
								alignSelf: 'center',
								marginTop: 20,
							}}
						>
							<CustomButton
								fontSize="15px"
								height="40px"
								id="add-btn"
								onClick={goToAddStaff}
								variant="primary"
								width="120px"
							>
								+ Add Staff
							</CustomButton>
						</div>
					</div>
				</div>

				<TableContainer className="staff-table-cont" component={Paper} id="Scrollable-table">
					<Table className="" stickyHeader style={{ width: '100%' }}>
						<TableHead>
							<TableRow>
								<TableCell className="bg-white staff-table-header">Staff Name</TableCell>
								<TableCell className="bg-white staff-table-header">Email</TableCell>
								<TableCell className="bg-white staff-table-header">Contact Number</TableCell>
								<TableCell className="bg-white staff-table-header">Emergency Number</TableCell>
								<TableCell className="bg-white staff-table-header">Actions</TableCell>
							</TableRow>
						</TableHead>
						<TableBody className="">
							{isLoading ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : !rows.length && !firstLoad ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										No Staff
									</TableCell>
								</TableRow>
							) : (
								rows?.map((row) => (
									<TableRow key={row.id}>
										<TableCell>
											<div
												className="flex items-center"
												id={`view-staff-${row.id}`}
												onClick={() => gotostaffinformation(row)}
												style={{ gap: 10, cursor: 'pointer' }}
											>
												<Avatar src={row.thumb} />
												<div className="flex flex-col">
													<div className="break-word font-bold" style={{ fontSize: 13 }}>
														{`${row.first_name} ${row.last_name}`}
													</div>
													<div className="break-word capitalize staff-position">{row.position_type}</div>
												</div>
											</div>
										</TableCell>
										<TableCell>
											<div className="break-word staff-email">{row.email}</div>
										</TableCell>
										<TableCell>
											<div className="break-word">{row.phone}</div>
										</TableCell>
										<TableCell>
											<div className="break-word">{row.emergency_phone}</div>
										</TableCell>
										<TableCell>
											<div className="flex items-center min-w-max">
												<IconButton id={`edit-staff-${row.id}`} onClick={() => goToEditStaff(row)} size="small">
													<img alt="edit" src="assets/images/circle-edit.png" width="25px" />
												</IconButton>
												<CustomSwitch
													checked={row.status === 1}
													id={`status-staff-${row.id}`}
													onChange={(e) => handleStatusChange(e, row)}
												/>
											</div>
										</TableCell>
									</TableRow>
								))
							)}
							{fetchingMore ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : null}
						</TableBody>
					</Table>
				</TableContainer>
				<InfiniteScroll
					dataLength={rows.length}
					hasMore={hasMore}
					next={handleLoadMore}
					scrollableTarget="Scrollable-table"
				/>
			</div>
		</FuseAnimate>
	);
};

export default StaffListing;
